import { Col, Form, Input, Row, Select } from "antd";
import { memo } from "react";

import { Box } from "../../../../../../../components";
import { aflTypeOptions, withPositionTypes } from "../../../constants";
import { Rules } from "../../../../../../../constants";
import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { StringHelper } from "../../../../../../../helper";
import { FormText } from "../../form-text";

interface Props {
  type: string;
  isSearchLoading?: boolean;
  onSearchUser?: (value: string) => Promise<void>;
  data?: any;
}

const { Search } = Input;

export const GeneralForm = memo(
  ({ type, data, isSearchLoading, onSearchUser }: Props) => {
    const isCreateForm = data === undefined;
    const isPositionField = withPositionTypes.includes(type);

    return (
      <Box title="Thông tin">
        <Row gutter={[32, 0]}>
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label="Loại đơn"
                name="eAFLType"
                rules={[Rules.required("Vui lòng chọn trường này!")]}
              >
                <Select
                  className="min-w-full"
                  options={aflTypeOptions}
                  placeholder="Chọn loại đơn..."
                />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft="Loại đơn"
                textRight={StringHelper.verticalBarSplit(data?.eAFLType)[1]}
              />
            )}
          </Col>
          {/* Id */}
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label="Mã nhân viên"
                name="eEmployeeId"
                rules={[Rules.required()]}
              >
                <Search
                  disabled={!type}
                  loading={isSearchLoading}
                  onSearch={onSearchUser}
                />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft="Mã nhân viên"
                textRight={data?.eEmployeeId}
              />
            )}
          </Col>
          {/* Name */}
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label="Họ tên"
                name="eRequestName"
                rules={[Rules.required()]}
              >
                <Input disabled />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft="Họ tên"
                textRight={data?.eRequestName}
              />
            )}
          </Col>
          {/* Department */}
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label="Cơ quan/Đơn vị"
                name="eDepartment"
                rules={[Rules.required("Vui lòng chọn trường này!")]}
              >
                <FormText />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft="Cơ quan/Đơn vị"
                textRight={StringHelper.verticalBarSplit(data?.eDepartment)[1]}
              />
            )}
          </Col>
          {/* Unit */}
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label="Đơn vị thuộc chi nhánh"
                name="eUnit"
                rules={[Rules.required("Vui lòng chọn trường này!")]}
              >
                <FormText />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft="Đơn vị thuộc chi nhánh"
                textRight={StringHelper.verticalBarSplit(data?.eUnit)[1]}
              />
            )}
          </Col>
          {/* Team */}
          <Col xs={24} md={12} xl={8}>
            {isCreateForm ? (
              <Form.Item
                label={isPositionField ? "Chức danh" : "Đội"}
                name="eTeam"
                rules={[Rules.required("Vui lòng chọn trường này!")]}
              >
                <FormText />
              </Form.Item>
            ) : (
              <BoxSectionItem
                ellipsis
                textLeft={isPositionField ? "Chức danh" : "Đội"}
                textRight={StringHelper.verticalBarSplit(data?.eTeam)[1]}
              />
            )}
          </Col>
        </Row>
      </Box>
    );
  }
);
